import React, { Component } from 'react'
import { connect } from "react-redux";
import { customSelectStyles } from "../../ThemeComponents/selectStyles";
import { Card } from "components/Card/Card.jsx";
import { withRouter } from 'react-router-dom';
import {
    Grid,
    Row,
    Col
} from "react-bootstrap";
import { helperFunctions as HF } from "helper/helperFunctions";
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import { addressActions } from "../../../redux/actions/address-actions";
import { listActions } from '../../../redux/actions/list-actions';
import { shippingOptionsActions } from "../../../redux/actions/shipping-options-actions";
import { contactActions } from "../../../redux/actions/contact-action";
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';
import Address from '../../ThemeComponents/Address';
import DatePicker from "react-date-picker";
import ThemeModal from '../../ThemeComponents/ThemeModal';
import BrandLogo from "./BrandLogo";
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import TagLayoutInfo from './TagLayoutInfo';
import ViewCartProductsList from './ViewCartProductsList';
import { hasPermission } from 'helper/hasPermission';
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";

var isEqual = require('lodash.isequal');

class OrderDetailForm extends Component {
    constructor(props) {
        super(props);
        this.validatorCustomer = new SimpleReactValidator();

        this.state = {
            showModal: false,
            shippingAddress: {
                create_address: 'edit',
                create_contact: 'edit',
                address_changed: 'false',
                contact_changed: 'false',
                shipping_option: '',
                ship_via: '',
                ship_via_id: '',
                ship_account: '',
                print_location: '',
                print_location_id: '',
                print_currency: '',
                special_instructions: '',
                address: {
                    id: '',
                    country_id: '',
                    country: '',
                    contact_name: '',
                    email: '',
                    phone: ''
                },
                oldAddress: {
                    id: '',
                    country_id: '',
                    country: '',
                    contact_name: '',
                    email: '',
                    phone: ''
                },
                oldContact: {
                    id: '',
                    selectedContact: '',
                    contact_name: '',
                    email: '',
                    phone: '',
                }
            },
            billingAddress: {
                create_address: 'edit',
                create_contact: 'edit',
                address_changed: 'false',
                contact_changed: 'false',
                ship_date: '',
                tracking_number: '',
                billing_status: '',
                comments: '',
                same_as_shipping: false,
                address: {
                    id: '',
                    country_id: '',
                    country: '',
                    contact_name: '',
                    email: '',
                    phone: ''
                },
                oldAddress: {
                    id: '',
                    country_id: '',
                    country: '',
                    contact_name: '',
                    email: '',
                    phone: ''
                },
                oldContact: {
                    id: '',
                    selectedContact: '',
                    contact_name: '',
                    email: '',
                    phone: '',
                }
            },
            checked: false,
            submitted: false,
            selectedBrand: null,
            selectedTaglayout: null,
            cart: null,
            filtered: "",
            cartProductspageSize: 10,
            productsData: [],
            userInfo: {},//JSON.parse(localStorage.getItem("user")).result.user,
            disable_order: false,
            user: JSON.parse(localStorage.getItem("user")).result.user,
        }
        this.onChange = this.onChange.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.getChildState = this.getChildState.bind(this);
        this.child = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        // don't forget to compare props
        if (
            this.props.currentStep !== prevProps.currentStep &&
            this.props.currentStep === 4
        ) {
            this.setState({
                ...this.state,
                selectedBrand: this.props.selectedBrand,
                selectedTaglayout: this.props.selectedTaglayout,
                cart: this.props.cart
            });
        }
    }

    deleteProductFromCart = (data) => {
        return this.props.deleteProductFromCartCall({
            product_ids: data,
            brand: this.props.selectedBrand
        }).then(response => {
            this.props.getCartProductsCall({
                cart: this.state.cart,
                brand: this.props.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.props.productAttributes,
                page: 1,
                sort: '',
                pageSize: this.state.cartProductspageSize
            }).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData
                });
            });
        });
    }

    saveCart = () => {
        let pids = [];
        let selected_pids = [];
        let chosen_atts = {};

        pids = this.state.productsData.map(p => p.id);

        let validation_failed = false;
        pids.forEach((prdId, idx) => {
            const product = this.state.productsData.find(
                item => item.id === prdId
            );
            this.props.orderAttributes.forEach(obj => {
                if (obj.adjust_product_attribute !== null) {
                    if (product[obj.adjust_product_attribute_name] < parseInt(product[obj.db_column]) && !this.state.productsData[idx].tag_layout.allow_quantity_increase) {
                        validation_failed = true;
                    }

                    if (parseInt(product[obj.db_column]) > 0) {
                        selected_pids = [...selected_pids, prdId];
                        chosen_atts[prdId] = this.state.productsData[idx];

                    }
                } else {
                    if (parseInt(product[obj.db_column]) > 0) {
                        selected_pids = [...selected_pids, prdId];
                        chosen_atts[prdId] = this.state.productsData[idx];
                    }
                }
            });
        });
        if (validation_failed) {
            $("#checkall").prop("checked", false);
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <Confirmalertfordelete msgType="warning" onClosePro={onClose} header="Validation Error!"
                            description="Order quantity cannot be more than available quantity!" />
                    )
                }
            })
            return;
        }

        //

        this.props.saveCartCall({
            brand: this.props.selectedBrand,
            orderAttributes: this.props.orderAttributes,
            productsData: this.state.productsData
        });
    }

    componentDidMount() {
        this.props.getAllShippingAddresses();
        this.props.getAllBillingAddresses();
        this.props.getListCall('country', "", "", "", "", "country", false);
        this.props.getListCall('print_location', "", "", "", "", "print_location", false);
        this.props.getListCall('print_currency', "", "", "", "", "print_currency", false);
        this.props.getListCall('order_status', "", "", "", "", "order_status", false);
        this.props.getShippingOptions('all');

        this.setState({ userInfo: JSON.parse(localStorage.getItem("user")).result.user }, function () {
            this.props.getAllContacts(this.state.userInfo.model_id, 'customer');
        });

        if (this.props.orderDetailsProp !== undefined) {
            this.setState(prevState => ({
                shippingAddress: {
                    ...prevState.shippingAddress,
                    address: {
                        ...prevState.shippingAddress.address,
                        ...this.props.orderDetailsProp.shippingaddress,

                        selectedContact: this.props.orderDetailsProp.shipping_contact_id,
                        contact_name: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.name : '',
                        email: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.email : '',
                        phone: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.phone : '',
                    },
                    oldAddress: {
                        ...prevState.shippingAddress.address,
                        ...this.props.orderDetailsProp.shippingaddress,

                        selectedContact: this.props.orderDetailsProp.shipping_contact_id,
                        contact_name: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.name : '',
                        email: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.email : '',
                        phone: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.phone : ''
                    },
                    oldContact: {
                        contact_name: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.name : '',
                        email: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.email : '',
                        phone: this.props.orderDetailsProp.shipping_contact ? this.props.orderDetailsProp.shipping_contact.phone : ''
                    },
                    ship_via: this.props.orderDetailsProp.ship_via,
                    ship_via_id: this.props.orderDetailsProp.ship_via_id,
                    ship_account: this.props.orderDetailsProp.ship_account,
                    print_location: this.props.orderDetailsProp.print_location,
                    print_location_id: this.props.orderDetailsProp.print_location_id,
                    print_currency: this.props.orderDetailsProp.print_currency_id,
                    special_instructions: this.props.orderDetailsProp.instructions
                },
                //---
                billingAddress: {
                    ...prevState.billingAddress,
                    address: {
                        ...prevState.billingAddress.address,
                        ...this.props.orderDetailsProp.billingaddress,

                        selectedContact: this.props.orderDetailsProp.billing_contact_id,
                        contact_name: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.name : '',
                        email: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.email : '',
                        phone: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.phone : ''
                    },
                    oldAddress: {
                        ...prevState.billingAddress.address,
                        ...this.props.orderDetailsProp.billingaddress,

                        selectedContact: this.props.orderDetailsProp.billing_contact_id,
                        contact_name: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.name : '',
                        email: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.email : '',
                        phone: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.phone : ''
                    },
                    oldContact: {
                        contact_name: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.name : '',
                        email: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.email : '',
                        phone: this.props.orderDetailsProp.billing_contact ? this.props.orderDetailsProp.billing_contact.phone : ''
                    },
                    tracking_number: this.props.orderDetailsProp.tracking_number,
                    shipped_by_contact: this.props.orderDetailsProp.shipped_by_contact,
                    ship_date: this.props.orderDetailsProp.ship_date ? new Date(this.props.orderDetailsProp.ship_date) : '',
                    billing_status: this.props.orderDetailsProp.status,
                    po_number: this.props.orderDetailsProp.po_number,
                    comments: this.props.orderDetailsProp.comments,
                    same_as_shipping: this.props.orderDetailsProp.shippingaddress.line1 && isEqual(this.props.orderDetailsProp.billingaddress, this.props.orderDetailsProp.shippingaddress)
                },
            }
            ));
        }

        // from view cart to checkout //
        if (this.props.fromCartPage === 'true') {
            this.setState({
                selectedBrand: this.props.selectedBrand,
                selectedTaglayout: this.props.selectedTaglayout,
                cart: this.props.cart,
                productAttributes: this.props.productAttributes,
                orderAttributes: this.props.orderAttributes,
                selectedFilterAttributes: this.props.selectedFilterAttributes,
            },
                () => {
                    ///this.refreshCartProducts();
                });
        }
    }

    viewCart = () => {
        this.setState({ showModal: !this.state.showModal }, function () {
            this.props.getCartProductsCall({
                cart: this.state.cart,
                brand: this.props.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.props.productAttributes,
                page: 1,
                sort: '',
                pageSize: this.state.cartProductspageSize
            }).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData
                });
            });
        });
    }

    productsPaginationData = (page, filter, sort, pageSize) => {
        this.setState({ cartProductspageSize: pageSize }, function () {
            this.props.getCartProductsCall({
                cart: this.state.cart,
                brand: this.props.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.props.productAttributes,
                page,
                sort,
                pageSize
            }).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData
                });
            });
        });
    };

    getAddressOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title }) => ({
            value: id,
            label: HF.Capitalize(title)
        }));
    }

    processShippingOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title, account }) => ({
            value: id,
            label: HF.Capitalize(title),
            account_value: account
        }));
    }

    getListOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title }) => ({
            value: id,
            label: HF.Capitalize(title)
        }));
    }

    getBillingListOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title }) => ({
            value: title,
            label: HF.Capitalize(title)
        }));
    }

    handleChangeShippingAddress(selectedOption, info, parentObject) {
        this.setState(prevState => ({
            shippingAddress: {
                ...prevState.shippingAddress,
                address: {
                    ...prevState.shippingAddress.address,
                    ...this.props.shippingAddresses.find(item => item.id === selectedOption.value)
                },
                oldAddress: {
                    ...prevState.shippingAddress.oldAddress,
                    ...this.props.shippingAddresses.find(item => item.id === selectedOption.value)
                }
            }
        }
        ));
    }

    handleChangeBillingAddress(selectedOption, info, parentObject) {
        this.setState(prevState => ({
            billingAddress: {
                ...prevState.billingAddress,
                address: {
                    ...prevState.billingAddress.address,
                    ...this.props.billingAddresses.find(item => item.id === selectedOption.value)
                },
                oldAddress: {
                    ...prevState.billingAddress.oldAddress,
                    ...this.props.billingAddresses.find(item => item.id === selectedOption.value)
                }
            }
        }
        ));
    }

    billingContactDropdownChangedHandler = (contact) => {
        contact.contact_name = contact.first_name + ' ' + contact.last_name;
        this.setState(prevState => ({
            billingAddress: {
                ...prevState.billingAddress,
                address: {
                    ...contact,
                    ...prevState.billingAddress.address,
                },
                oldContact: {
                    ...contact,
                    ...prevState.billingAddress.oldContact,
                }
            }
        }
        ));
    }

    shippingContactDropdownChangedHandler = (contact) => {
        contact.contact_name = contact.first_name + ' ' + contact.last_name;
        this.setState(prevState => ({
            shippingAddress: {
                ...prevState.shippingAddress,
                address: {
                    ...contact,
                    ...prevState.shippingAddress.address,
                },
                oldContact: {
                    ...contact,
                    ...prevState.shippingAddress.oldContact,
                }
            }
        }
        ));
    }

    handleChangeDropdown(selectedOption, info) {
        if (info.name === 'ship_via') {
            this.setState(prevState => ({
                shippingAddress: {
                    ...prevState.shippingAddress,
                    ship_via_id: selectedOption.value,
                    ship_via: selectedOption.label,
                    ship_account: selectedOption.account_value !== null ? selectedOption.account_value : ''
                }
            }
            ));
        }
        if (info.name === 'print_location') {
            this.setState(prevState => ({
                shippingAddress: {
                    ...prevState.shippingAddress,
                    print_location: selectedOption.label,
                    print_location_id: selectedOption.value,
                }
            }
            ));
        }
        if (info.name === 'print_currency') {
            this.setState(prevState => ({
                shippingAddress: {
                    ...prevState.shippingAddress,
                    print_currency: selectedOption.value
                }
            }
            ));
        }
        if (info.name === 'billing_status') {
            this.setState(prevState => ({
                billingAddress: {
                    ...prevState.billingAddress,
                    billing_status: selectedOption.value
                }
            }
            ));
        }
    }

    handleCheck(e) {
        const checked = e.target.checked;

        if (checked) {
            this.setState({
                billingAddress: {
                    ...this.state.billingAddress,
                    address: this.state.shippingAddress.address,
                    same_as_shipping: checked
                }
            });
        } else {
            this.setState({
                billingAddress: {
                    ...this.state.billingAddress,
                    address: this.state.billingAddress.oldAddress,
                    same_as_shipping: checked
                }
            });
        }
    }

    onChange(e) {
        const container = e.target.name.split('.');
        this.setState({
            [container[0]]: {
                ...this.state[container[0]],
                [container[1]]: e.target.value
            }
        });
    }

    getShippingState = (state) => {
        this.setState(prevState => ({
            shippingAddress: {
                ...prevState.shippingAddress,
                ...state
            },
        }))
    }

    getBillingState = (state) => {
        this.setState(prevState => ({
            billingAddress: {
                ...prevState.billingAddress,
                ...state
            }
        }))
    }

    radioButtonChanged = (type, type2, value) => {
        if (type === 'shipping') {
            if (type2 === 'contact') {
                this.setState(prevState => ({
                    shippingAddress: {
                        ...prevState.shippingAddress,
                        create_contact: value
                    }
                }));
            } else {
                this.setState(prevState => ({
                    shippingAddress: {
                        ...prevState.shippingAddress,
                        create_address: value
                    }
                }));
            }
        } else if (type === 'billing') {
            if (type2 === 'contact') {
                this.setState(prevState => ({
                    billingAddress: {
                        ...prevState.billingAddress,
                        create_contact: value
                    }
                }));
            } else {
                this.setState(prevState => ({
                    billingAddress: {
                        ...prevState.billingAddress,
                        create_address: value
                    }
                }));
            }
        }
    }

    compareContactChange = (type) => {
        const { shippingAddress, billingAddress } = this.state;
        if (type === 'shipping') {
            if (shippingAddress.address.selectedContact !== undefined && shippingAddress.address.selectedContact !== "") {
                return shippingAddress.address.contact_name !== shippingAddress.oldContact.contact_name ||
                    shippingAddress.address.phone !== shippingAddress.oldContact.phone ||
                    shippingAddress.address.email !== shippingAddress.oldContact.email;
            } else {
                return false;
            }
        } else if (type === 'billing') {
            if (billingAddress.address.selectedContact !== undefined && billingAddress.address.selectedContact !== "") {
                return billingAddress.address.contact_name !== billingAddress.oldContact.contact_name ||
                    billingAddress.address.phone !== billingAddress.oldContact.phone ||
                    billingAddress.address.email !== billingAddress.oldContact.email;
            } else {
                return false;
            }
        }
    }

    compareAddressChange = (type) => {
        const { shippingAddress, billingAddress } = this.state;
        if (type === 'shipping') {
            if (shippingAddress.address.id !== undefined && shippingAddress.address.id !== "") {
                return shippingAddress.address.line1 !== shippingAddress.oldAddress.line1 ||
                    shippingAddress.address.country_id !== shippingAddress.oldAddress.country_id ||
                    shippingAddress.address.city !== shippingAddress.oldAddress.city ||
                    shippingAddress.address.zip_post_code !== shippingAddress.oldAddress.zip_post_code ||
                    shippingAddress.address.title !== shippingAddress.oldAddress.title ||
                    shippingAddress.address.region_id !== shippingAddress.oldAddress.region_id;
            } else {
                return false;
            }
        } else if (type === 'billing') {
            if (billingAddress.address.id !== undefined && billingAddress.address.id !== "") {
                return billingAddress.address.line1 !== billingAddress.oldAddress.line1 ||
                    billingAddress.address.country_id !== billingAddress.oldAddress.country_id ||
                    billingAddress.address.city !== billingAddress.oldAddress.city ||
                    billingAddress.address.zip_post_code !== billingAddress.oldAddress.zip_post_code ||
                    shippingAddress.address.title !== shippingAddress.oldAddress.title ||
                    billingAddress.address.region_id !== billingAddress.oldAddress.region_id;
            } else {
                return false;
            }
        }
    }

    handlePlaceOrder = (e) => {
        e.preventDefault();
        if (this.validatorCustomer.allValid()) {
            this.setState(prevState => ({
                shippingAddress: {
                    ...prevState.shippingAddress,
                    address_changed: this.compareAddressChange('shipping') ? 'true' : 'false',
                    contact_changed: this.compareContactChange('shipping') ? 'true' : 'false'
                },
                billingAddress: {
                    ...prevState.billingAddress,
                    address_changed: this.compareAddressChange('billing') ? 'true' : 'false',
                    contact_changed: this.compareContactChange('billing') ? 'true' : 'false'
                }
            }),
                () => {
                    if (this.props.showViewCart === "true") {
                        this.props.placeOrderCall({
                            brand: this.props.selectedBrand,
                            productAttributes: this.props.productAttributes,
                            orderAttributes: this.props.orderAttributes,
                            taglayout: this.props.selectedTaglayout,
                            cart: this.props.cart,
                            shippingAddress: this.state.shippingAddress,
                            billingAddress: this.state.billingAddress,
                            customer_id: this.state.userInfo.model_id
                        });
                    } else {
                        this.props.saveOrderCall({
                            order: this.props.orderDetailsProp,
                            shippingAddress: this.state.shippingAddress,
                            billingAddress: this.state.billingAddress
                        });
                    }
                });
        } else {
            this.validatorCustomer.showMessages();
            this.forceUpdate();
        }
    }

    onChangeDate(value, field) {
        this.setState(
            {
                billingAddress: {
                    ...this.state.billingAddress,
                    ship_date: value
                }
            }
        );
    }

    getChildState(childData) {
        this.setState({
            addressObj: childData
        });
    }

    changeHandler = (e, id, index) => {
        e.preventDefault();
        const name = e.target.name;
        let productsData = [...this.state.productsData];
        let item = { ...productsData[index] };
        item[name] = e.target.value;
        productsData[index] = item;
        this.setState({ productsData });
    };

    continueShopping = (type) => {
        if (type === 'close-view-cart') {
            this.setState({ showModal: !this.state.showModal },
                () => {
                    setTimeout(() => {
                        this.props.resetLookupState();
                        this.props.goToStep(3);
                    }, 1000);
                });
        } else {
            this.props.resetLookupState();
            this.props.goToStep(3);
        }
    }

    disable_order_form = () => {
        if (this.state.user) {
            if (this.state.user.roles[0].name === 'customer manager') {
                if (this.props.orderDetailsProp.status === 'new' || !this.props.orderDetailsProp.status) {
                    return false
                } else {
                    return true
                }
            } else {
                return hasPermission('edit-order-details') ? false : true;
            }
        }
        return false;
    }

    render() {
        const {
            ship_via,
            ship_via_id,
            ship_account,
            print_location_id,
            print_currency,
            special_instructions
        } = this.state.shippingAddress;
        const { shipped_by_contact, tracking_number, po_number, billing_status, comments } = this.state.billingAddress;
        return (<Grid fluid>
            <Row>
                <Col md={12}>
                    <Card
                        ctTableResponsive
                        content={
                            <div>
                                <Grid fluid>
                                    <Row>
                                        <Col md={12}>
                                            {this.props.showViewCart === "true" &&
                                                <h3 style={{ textAlign: 'center', fontWeight: "500" }}>Checkout Cart</h3>
                                            }
                                            <div className="col-md-12">
                                                <div className="flexElem alignCenter spaceBetween">
                                                    <div>
                                                        <h4>Order <span className="linkColor">#
                                                            {this.props.cart && this.props.cart.order &&
                                                                <span>{this.props.cart.order.id}</span>
                                                            }

                                                            {
                                                                this.props.orderDetailsProp !== undefined && this.props.orderDetailsProp.id
                                                            }</span>

                                                            {
                                                                this.props.orderDetailsProp !== undefined &&
                                                                '  (' + this.props.orderDetailsProp.brand + ')'
                                                            }
                                                        </h4>
                                                    </div>
                                                    {this.props.showViewCart === "true" &&
                                                        <div>
                                                            <button type="button" onClick={this.viewCart}
                                                                className="customBtn btnBlue m-md btn-lg">
                                                                View Cart
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                            </div>


                                            <form onSubmit={this.handlePlaceOrder}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="cardBox">
                                                            {
                                                                this.props.hasShippingAddresses ?
                                                                    <div
                                                                        className="flexElem flexResponsive halfCols alignFlexCenter">
                                                                        <div className="mt-xs fieldWithIcon">
                                                                            <h4 className="mt-none mb-none">Shipping
                                                                                Address</h4>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <h4 className="mt-none mb-none">Shipping
                                                                        Address</h4>
                                                            }

                                                            <Address
                                                                extraHtml={
                                                                    this.props.hasShippingAddresses &&
                                                                    <div
                                                                        className="mt-md fieldWithIcon"
                                                                        id={this.props.htmlElement + "Country"}
                                                                    >
                                                                        <span className="fieldIcon locationIcon"></span>
                                                                        <Select
                                                                            value={HF.returnLabelWithValue(
                                                                                this.state.shippingAddress.address.id,
                                                                                this.getAddressOptions(this.props.shippingAddresses)
                                                                            )}
                                                                            styles={customSelectStyles}
                                                                            options={this.getAddressOptions(this.props.shippingAddresses)}
                                                                            isSearchable={false}
                                                                            isMulti={false}
                                                                            name="country"
                                                                            isClearable={false}
                                                                            isDisabled={this.disable_order_form()}
                                                                            placeholder={"Select Address"}
                                                                            onChange={(event, info) =>
                                                                                this.handleChangeShippingAddress(
                                                                                    event,
                                                                                    info
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                }
                                                                onContactDropdownChanged={this.shippingContactDropdownChangedHandler}
                                                                addressPro={this.state.shippingAddress.address}
                                                                addressObject={this.state.shippingAddress.address}
                                                                contacts={this.props.contacts}
                                                                countries={this.props.country}
                                                                htmlElement={'customer'}
                                                                type={'shippingAddress'}
                                                                shippingAddress={true}
                                                                options={
                                                                    {
                                                                        'countries': this.props.countries
                                                                    }
                                                                }
                                                                requiredField={
                                                                    {
                                                                        'contact_name': 'required',
                                                                        'street_address_1': 'required',
                                                                        'country_id': 'required',
                                                                        'city': 'required',
                                                                        'state_id': 'required',
                                                                        'zipcode': '',
                                                                        phone: 'required',
                                                                        email: 'required',
                                                                    }
                                                                }
                                                                getChildState={this.getChildState}
                                                                returnState={this.getShippingState}
                                                                validatorInstance={this.validatorCustomer}
                                                                in_order={true}
                                                                disable_order_detail={this.disable_order_form()}
                                                            />

                                                            <div
                                                                className="flexElem flexResponsive halfCols alignFlexCenter text-capitalize">
                                                                <div
                                                                    className="mt-md fieldWithIcon"
                                                                    id={this.props.htmlElement + "ShipVia"}>
                                                                    <span className="fieldIcon shipping"></span>
                                                                    <input type="text" placeholder="Ship Via"
                                                                        name="shippingAddress.ship_via"
                                                                        className="form-control"
                                                                        value={ship_via || ''}
                                                                        disabled={this.disable_order_form()}
                                                                        onChange={this.onChange} />
                                                                    {
                                                                        <span className="customMsg">
                                                                            {this.validatorCustomer.message(
                                                                                "Ship Via",
                                                                                ship_via,
                                                                                'required'
                                                                            )}
                                                                        </span>
                                                                    }
                                                                </div>

                                                                <div
                                                                    className="mt-md fieldWithIcon"
                                                                    id={this.props.htmlElement + "State"}>
                                                                    <span className="fieldIcon acc_number"></span>
                                                                    <input type="text" placeholder="Shipping Account #"
                                                                        name="shippingAddress.ship_account"
                                                                        className="form-control"
                                                                        value={ship_account || ''}
                                                                        disabled={this.disable_order_form()}
                                                                        onChange={this.onChange} />
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="flexElem flexResponsive halfCols alignFlexCenter text-capitalize">
                                                                <div
                                                                    className="mt-md fieldWithIcon"
                                                                    id={this.props.htmlElement + "State"}>
                                                                    <span className="fieldIcon locationIcon"></span>
                                                                    <Select
                                                                        value={HF.returnLabelWithValue(print_location_id, this.getListOptions(this.props.printLocations))}
                                                                        onChange={(event, info) => this.handleChangeDropdown(event, info)}
                                                                        options={this.getListOptions(this.props.printLocations)}
                                                                        isSearchable={false}
                                                                        isMulti={false}
                                                                        name='print_location'
                                                                        isClearable={this.props.isClearableCountryPro}
                                                                        isDisabled={this.disable_order_form()}
                                                                        placeholder={'Print Location'}
                                                                    />
                                                                    {
                                                                        <span className="customMsg">
                                                                            {this.validatorCustomer.message(
                                                                                "Print Location",
                                                                                print_location_id,
                                                                                'required'
                                                                            )}
                                                                        </span>
                                                                    }
                                                                </div>

                                                                <div
                                                                    className="mt-md fieldWithIcon"
                                                                    id="currency_drop_down">
                                                                    <span className="fieldIcon currency"></span>
                                                                    <Select
                                                                        value={HF.returnLabelWithValue(print_currency, this.getListOptions(this.props.printCurrency))}
                                                                        onChange={(event, info) => this.handleChangeDropdown(event, info)}
                                                                        options={this.getListOptions(this.props.printCurrency)}
                                                                        isSearchable={false}
                                                                        isMulti={false}
                                                                        name='print_currency'
                                                                        isClearable={this.props.isClearableCountryPro}
                                                                        isDisabled={this.disable_order_form()}
                                                                        placeholder={'Print Currency'}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="flexElem flexResponsive alignFlexCenter text-capitalize">
                                                                <div className="mt-md" style={{ width: '100%' }}>
                                                                    <textarea type="text" style={{ height: '123px' }}
                                                                        placeholder="Special Instructions"
                                                                        name='shippingAddress.special_instructions'
                                                                        className="form-control"
                                                                        value={special_instructions || ''}
                                                                        disabled={this.disable_order_form()}
                                                                        onChange={this.onChange} />
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>


                                                    <div className="col-md-6">
                                                        <div className="cardBox" style={{ paddingTop: '20px' }}>
                                                            {
                                                                this.props.hasBillingAddresses ?
                                                                    <div
                                                                        className="flexElem flexResponsive halfCols alignFlexCenter">
                                                                        <div className="mt-md fieldWithIcon">
                                                                            <h4 className="mt-none mb-none">Billing
                                                                                Address</h4>
                                                                        </div>

                                                                        <div>
                                                                            <label
                                                                                className="container-check mt-sm mb-none">
                                                                                Same as shipping address
                                                                                <input type="checkbox"
                                                                                    onChange={this.handleCheck}
                                                                                    checked={this.state.billingAddress.same_as_shipping}
                                                                                    disabled={this.disable_order_form()}
                                                                                />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <h4 className="mt-none mb-none">Billing Address</h4>
                                                            }

                                                            <Address
                                                                extraHtml={
                                                                    this.props.hasBillingAddresses &&
                                                                    <div
                                                                        className="mt-md fieldWithIcon"
                                                                        id={this.props.htmlElement + "Country"}
                                                                    >
                                                                        <span className="fieldIcon locationIcon"></span>
                                                                        <Select
                                                                            styles={customSelectStyles}
                                                                            options={this.getAddressOptions(this.props.billingAddresses)}
                                                                            isSearchable={false}
                                                                            isMulti={false}
                                                                            name="country"
                                                                            isClearable={false}
                                                                            placeholder={"Select Address"}
                                                                            onChange={(event, info) =>
                                                                                this.handleChangeBillingAddress(
                                                                                    event,
                                                                                    info
                                                                                )
                                                                            }
                                                                            isDisabled={this.state.billingAddress.same_as_shipping || this.disable_order_form()}
                                                                        />
                                                                    </div>
                                                                }
                                                                onContactDropdownChanged={this.billingContactDropdownChangedHandler}
                                                                addressPro={this.state.billingAddress.address}
                                                                addressObject={this.state.billingAddress.address}
                                                                contacts={this.props.contacts}
                                                                countries={this.props.country}
                                                                htmlElement={'customer'}
                                                                checked={this.state.checked}
                                                                type={'billingAddress'}
                                                                shippingAddress={true}
                                                                sameAsShippingProp={this.state.billingAddress.same_as_shipping}
                                                                options={
                                                                    {
                                                                        'countries': this.props.countries
                                                                    }
                                                                }
                                                                requiredField={{
                                                                    'contact_name': 'required',
                                                                    'street_address_1': 'required',
                                                                    'country_id': 'required',
                                                                    'city': 'required',
                                                                    'state_id': 'required',
                                                                    'zipcode': '',
                                                                    phone: 'required',
                                                                    email: 'required',
                                                                }
                                                                }
                                                                getChildState={this.getChildState}
                                                                returnState={this.getBillingState}
                                                                validatorInstance={this.validatorCustomer}
                                                                in_order={true}
                                                                disable_order_detail={this.disable_order_form()}
                                                            />
                                                            <div
                                                                className="flexElem flexResponsive halfCols alignFlexCenter text-capitalize">
                                                                {hasPermission('change-order-status') &&
                                                                    <div
                                                                        className="mt-md blueIcons"
                                                                        id={this.props.htmlElement + "ShipDate"}>
                                                                        <span>Ship Date:</span>
                                                                        <DatePicker
                                                                            className="form-control"
                                                                            onChange={this.onChangeDate}
                                                                            value={this.state.billingAddress.ship_date}
                                                                            placeholderText={`11/06/2019`}
                                                                            name="ship_date"
                                                                            disabled={this.disable_order_form()}
                                                                        />
                                                                    </div>
                                                                }
                                                                {hasPermission('change-order-status') &&
                                                                    <div className="mt-md">
                                                                        <span>Tracking Number:</span>
                                                                        <div
                                                                            className="fieldWithIcon"
                                                                            id={this.props.htmlElement + "State"}>
                                                                            <span className="fieldIcon tracking"></span>
                                                                            <input type="text" placeholder="Tracking Number"
                                                                                name="billingAddress.tracking_number"
                                                                                className="form-control"
                                                                                value={tracking_number}
                                                                                disabled={this.disable_order_form()}
                                                                                onChange={this.onChange} />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>

                                                            {hasPermission('change-order-status') &&
                                                                <div
                                                                    className="flexElem flexResponsive halfCols alignFlexCenter text-capitalize">
                                                                    <div
                                                                        className="mt-md fieldWithIcon"
                                                                        // style={{ marginLeft: '0px', marginRight: '0px' }}
                                                                        id={this.props.htmlElement + "State"}>
                                                                        <span className="fieldIcon status"></span>
                                                                        <Select
                                                                            value={HF.returnLabelWithValue(billing_status, this.getBillingListOptions(this.props.orderStatuses))}
                                                                            onChange={(event, info) => this.handleChangeDropdown(event, info)}
                                                                            options={this.getBillingListOptions(this.props.orderStatuses)}
                                                                            isSearchable={false}
                                                                            isMulti={false}
                                                                            name='billing_status'
                                                                            isClearable={this.props.isClearableCountryPro}
                                                                            isDisabled={this.disable_order_form()}
                                                                            placeholder={'Status'}
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        className="mt-md fieldWithIcon"
                                                                    >
                                                                        <span className="fieldIcon userIcon"></span>
                                                                        <input type="text" placeholder="Shipped By Contact"
                                                                            name="billingAddress.shipped_by_contact"
                                                                            className="form-control"
                                                                            value={shipped_by_contact}
                                                                            disabled={this.disable_order_form()}
                                                                            onChange={this.onChange} />
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div
                                                                className="mt-md fieldWithIcon"
                                                            >
                                                                <span className="fieldIcon tracking"></span>
                                                                <input type="text" placeholder="Billing PO Number"
                                                                    name="billingAddress.po_number"
                                                                    className="form-control"
                                                                    value={po_number}
                                                                    disabled={this.disable_order_form()}
                                                                    onChange={this.onChange} />
                                                            </div>

                                                            {hasPermission('change-order-status') &&
                                                                <div
                                                                    className="flexElem flexResponsive alignFlexCenter text-capitalize">
                                                                    <div style={{ width: '100%' }}
                                                                        className="mt-md"
                                                                        id={this.props.htmlElement + "State"}>
                                                                        <span className="fieldIcon stateIcon"></span>
                                                                        <textarea placeholder="Comments"
                                                                            style={{ height: '123px' }} type="text"
                                                                            name="billingAddress.comments"
                                                                            className="form-control" value={comments}
                                                                            disabled={this.disable_order_form()}
                                                                            onChange={this.onChange} />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                {
                                                    this.props.showViewCart === "false" &&
                                                    <div className="text-center">
                                                        <input
                                                            type="submit"
                                                            value="Save Order"
                                                            className="customBtn btnBlack m-md"
                                                            disabled={this.disable_order_form()}
                                                        />
                                                    </div>
                                                }

                                                <div className="text-center">
                                                    {
                                                        this.props.showViewCart === "true" &&
                                                        <input
                                                            type="submit"
                                                            value="Place Order"
                                                            className="customBtn btnBlack m-md"
                                                            disabled={this.disable_order_form()}
                                                        />
                                                    }

                                                    {(this.props.fromCartPage === 'false' && this.props.showViewCart === 'true') &&
                                                        <button type="button" onClick={() => this.continueShopping()}
                                                            className="customBtn btnBlue m-md btn-lg">
                                                            Add More Items
                                                        </button>
                                                    } </div>

                                            </form>
                                        </Col>
                                    </Row>
                                </Grid>
                            </div>
                        }
                    />

                    <ThemeModal title="Shopping Cart" hide={() => {
                        this.setState({ showModal: !this.state.showModal })
                    }} show={this.state.showModal} size="full">
                        <div className="flexElem respFlex spaceBetween respFlex">
                            <div className="brandInfo flexElem respFlex alignCenter">
                                <BrandLogo brand={this.state.selectedBrand} customClasses="ml-md text_16" />
                            </div>
                        </div>
                        <div className="mt-xlg">
                            <ViewCartProductsList
                                productsData={this.state.productsData}
                                productAttributesProp={this.props.productAttributes}
                                orderAttributesProp={this.props.orderAttributes}
                                exportAttributes={this.props.exportAttributes}
                                cart={this.props.cart}
                                selectedBrand={this.props.selectedBrand}
                                productsPaginationData={this.productsPaginationData}
                                pageSize={this.state.cartProductspageSize}
                                filtered={this.state.filtered}
                                pages={this.props.pages}
                                loading={this.props.loading}
                                deleteProductFromCart={this.deleteProductFromCart}
                                changeHandler={this.changeHandler}
                                ref={this.child}
                            />
                        </div>
                        <div className="mt-lg text-center">
                            {(this.props.fromCartPage === 'false' && this.props.showViewCart === 'true') &&
                                <button type="button" onClick={() => this.continueShopping('close-view-cart')}
                                    className="customBtn btnBlue m-md btn-lg">
                                    Add More Items
                                </button>
                            }
                            <button type="button" className="customBtn btnBlack m-md btn-lg" onClick={this.saveCart}>
                                Save
                            </button>


                        </div>
                    </ThemeModal>
                </Col>
            </Row>
        </Grid>)
    }
}


const mapDispatchToProps = dispatch => {
    return ({
        getListCall: (
            id, page, filter, sort, pageSize, component_name, pagination
        ) => {
            dispatch(
                listActions.getList(
                    id, page, filter, sort, pageSize, component_name, pagination
                )
            );
        },
        getShippingOptions: custId => {
            dispatch(shippingOptionsActions.getCustomerShippingOptions(custId));
        },
        getCartProductsCall: (data) => {
            return dispatch(createOrderActions.getCartProductsPagination(data))
        },
        getAllShippingAddresses: () => {
            dispatch(addressActions.getAllShippingAddresses())
        },
        getAllBillingAddresses: () => {
            dispatch(addressActions.getAllBillingAddresses())
        },
        deleteProductFromCartCall: (data) => {
            return dispatch(createOrderActions.deleteProductFromCart(data))
        },
        placeOrderCall: (data) => {
            return dispatch(createOrderActions.placeOrder(data))
        },
        saveOrderCall: (data) => {
            return dispatch(createOrderActions.saveOrder(data))
        },
        getAllContacts: (model_id, model) => {
            dispatch(contactActions.getCustomerContact(model_id, model))
        },
        saveCartCall: (data) => {
            dispatch(createOrderActions.saveCart(data))
        },
    });
};

function mapStateToProps(state) {

    const { country, print_location, print_currency, order_status } = state.listReducer;
    const { shippingAddresses, billingAddresses } = state.addressReducer;
    const { shippingOptions } = state.shippingOptionReducer;
    const { contactsData } = state.customerReducer;

    const {
        productsData,
        pages,
        current_page,
        total_orders
    } = state.createOrdersReducer;

    return {
        country,
        productsData,
        pages,
        current_page,
        total_orders,
        shippingAddresses,
        billingAddresses,
        shippingOptions,
        printLocations: print_location,
        printCurrency: print_currency,
        orderStatuses: order_status,
        contacts: contactsData ? contactsData.filter(item => item.type !== 'primary') : []
    };
}

OrderDetailForm.defaultProps = {
    orderDetailsProp: OC.ORDER_DETAIL_PROP
}

const OrderDetail = connect(mapStateToProps, mapDispatchToProps)(OrderDetailForm);
export default withRouter(OrderDetail);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/OrderDetailForm.jsx